import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e20f3280"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-confirm-page" }
const _hoisted_2 = { class: "checkout-confirm-page__content" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "checkout-confirm-page__section" }
const _hoisted_5 = { class: "heading heading--3 checkout-confirm-page__section-title" }
const _hoisted_6 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_7 = { class: "checkout-confirm-page__info-item-value" }
const _hoisted_8 = { style: {"padding-right":"1em"} }
const _hoisted_9 = { class: "checkout-confirm-page__section" }
const _hoisted_10 = { class: "heading heading--3 checkout-confirm-page__section-title" }
const _hoisted_11 = { class: "checkout-confirm-page__info-item" }
const _hoisted_12 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_13 = { class: "iconed-text" }
const _hoisted_14 = {
  key: 0,
  class: "checkout-confirm-page__info-item-value"
}
const _hoisted_15 = {
  key: 0,
  class: "checkout-confirm-page__section"
}
const _hoisted_16 = { class: "heading heading--3 checkout-confirm-page__section-title" }
const _hoisted_17 = { class: "checkout-confirm-page__info-item" }
const _hoisted_18 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_19 = { class: "checkout-confirm-page__info-item-value" }
const _hoisted_20 = { class: "checkout-confirm-page__section" }
const _hoisted_21 = { class: "heading heading--3 checkout-confirm-page__section-title" }
const _hoisted_22 = { class: "checkout-confirm-page__info-item" }
const _hoisted_23 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_24 = { class: "checkout-confirm-page__section" }
const _hoisted_25 = { class: "heading heading--3 checkout-confirm-page__section-title" }
const _hoisted_26 = { class: "checkout-confirm-page__info-item" }
const _hoisted_27 = { class: "checkout-confirm-page__info-item-label" }

import AppHeader from '@/components/AppHeader.vue';
// eslint-disable-next-line import/no-cycle
import { useTelegramWebApp } from '@/services/telegram-web-app';
import { computed, onMounted, ref } from 'vue';
import IconMapPin from '@/icons/icon-map-pin.vue';
import AppAlert from '@/components/AppAlert.vue';
import IconWarning from '@/icons/icon-warning.vue';
import useCheckoutStore from '@/store/checkout';
import { Coupon, Order } from '@/types/app';
import api from '@/repositories/api';
import { useI18n } from 'vue-i18n';
import useAppConfigStore from '@/store/app-config';
import { onUnmounted } from '@vue/runtime-core';
import helpers from '../../helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutConfirmPage',
  setup(__props) {

const checkoutStore = useCheckoutStore();
const appConfigStore = useAppConfigStore();
const order = computed<Order>(() => checkoutStore.order!);
const coupon = computed<Coupon|undefined>(() => checkoutStore.coupon);
const telegramWebApp = useTelegramWebApp();
const orderPayUrl = ref<string>();
const i18n = useI18n();
const shippingMethodAddress = computed(() => (checkoutStore.order!.shippingMethodCode === 'pickup'
  ? appConfigStore.config.store.addresses[0].address
  : checkoutStore.order!.shippingAddress));
const shippingCost: number|null = checkoutStore.order!.shippingMethodCode === 'pickup' ? null : order.value.totals.find((e) => e.code === 'shipping')?.value || 0;

const payOrder = async () => {
  telegramWebApp.showMainBtnProgress();
  if (!orderPayUrl.value) {
    const response = await api.payOrderViaTelegram(order.value.orderId);
    orderPayUrl.value = response.data?.url;
  }
  if (!orderPayUrl.value) {
    telegramWebApp.close();
    return;
  }
  telegramWebApp.openInvoice(orderPayUrl.value, (status) => {
    /**
     * @ts-ignore */
    if (status !== 'pending') {
      telegramWebApp.hideMainBtnProgress();
    }
    /**
     * @ts-ignore */
    if (status === 'paid') {
      telegramWebApp.close();
      /**
       * @ts-ignore */
    } else if (status === 'failed') {
      telegramWebApp.showAlert(i18n.t('errorPaymentTryAgain'));
    }
  });
};

onMounted(() => {
  telegramWebApp.showMainBtn(i18n.t('toConfirmOrder'), payOrder);
});

onUnmounted(() => {
  telegramWebApp.removeMainBtnHandler(payOrder);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      title: _ctx.$t('yourOrder'),
      "with-search": false
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('orderProducts')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.products, (orderProduct) => {
            return (_openBlock(), _createElementBlock("div", {
              key: orderProduct.orderProductId,
              class: "checkout-confirm-page__info-item"
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(orderProduct.name), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, "x" + _toDisplayString(orderProduct.quantity), 1),
                _createTextVNode(" " + _toDisplayString(_unref(helpers).formatCurrency(orderProduct.price)), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(order.value.shippingMethod), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(IconMapPin),
                _createTextVNode(" " + _toDisplayString(shippingMethodAddress.value), 1)
              ])
            ]),
            (_unref(shippingCost) !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(helpers).formatCurrency(_unref(shippingCost))), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (coupon.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('promocode')), 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(coupon.value.code), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(coupon.value.type === "P"
                ? `-${coupon.value.discount}%`
                : `-${_unref(helpers).formatCurrency(coupon.value.discount)}`), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('total')), 1),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(helpers).formatCurrency(order.value.total)), 1)
          ]),
          _createVNode(AppAlert, { class: "checkout-confirm-page__alert" }, {
            icon: _withCtx(() => [
              _createVNode(IconWarning)
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('priceCanBeChange')) + " ", 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t('payment')), 1),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(order.value.paymentMethod), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})